import {
  GET_OLD_METAL_TYPES_REQUEST,
  GET_OLD_METAL_TYPES_SUCCESS,
  GET_OLD_METAL_TYPES_FAILURE,
  GET_OLD_METAL_STOCK_REQUEST,
  GET_OLD_METAL_STOCK_SUCCESS,
  GET_OLD_METAL_STOCK_FAILURE,
  UPDATE_OLD_METAL_STOCK_REQUEST,
  UPDATE_OLD_METAL_STOCK_SUCCESS,
  UPDATE_OLD_METAL_STOCK_FAILURE,
  GET_OLD_METAL_EXCHANGES_REQUEST,
  GET_OLD_METAL_EXCHANGES_SUCCESS,
  GET_OLD_METAL_EXCHANGES_FAILURE,
  GET_OLD_METAL_EXCHANGE_SUMMARY_REQUEST,
  GET_OLD_METAL_EXCHANGE_SUMMARY_SUCCESS,
  GET_OLD_METAL_EXCHANGE_SUMMARY_FAILURE,
} from '../types';

const initialState = {
  oldMetalTypes: [],
  oldMetalStock: [],
  oldMetalExchanges: [],
  oldMetalExchangeSummary: [],
  loading: false,
  error: null,
};

const oldMetalReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OLD_METAL_TYPES_REQUEST:
    case GET_OLD_METAL_STOCK_REQUEST:
    case UPDATE_OLD_METAL_STOCK_REQUEST:
    case GET_OLD_METAL_EXCHANGES_REQUEST:
    case GET_OLD_METAL_EXCHANGE_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_OLD_METAL_TYPES_SUCCESS:
      return {
        ...state,
        oldMetalTypes: action.payload,
        loading: false,
        error: null,
      };

    case GET_OLD_METAL_STOCK_SUCCESS:
      return {
        ...state,
        oldMetalStock: action.payload,
        loading: false,
        error: null,
      };

    case UPDATE_OLD_METAL_STOCK_SUCCESS:
      return {
        ...state,
        oldMetalStock: state.oldMetalStock.map(stock => 
          stock.id === action.payload.id ? action.payload : stock
        ),
        loading: false,
        error: null,
      };

    case GET_OLD_METAL_EXCHANGES_SUCCESS:
      return {
        ...state,
        oldMetalExchanges: action.payload,
        loading: false,
        error: null,
      };

    case GET_OLD_METAL_EXCHANGE_SUMMARY_SUCCESS:
      return {
        ...state,
        oldMetalExchangeSummary: action.payload,
        loading: false,
        error: null,
      };

    case GET_OLD_METAL_TYPES_FAILURE:
    case GET_OLD_METAL_STOCK_FAILURE:
    case UPDATE_OLD_METAL_STOCK_FAILURE:
    case GET_OLD_METAL_EXCHANGES_FAILURE:
    case GET_OLD_METAL_EXCHANGE_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default oldMetalReducer;
